import PaymentMethods from'./PaymentMethods'
import PaymentFlags from'./PaymentFlags'

export default {
    'payment-methods': PaymentMethods,
    'payment-flags': PaymentFlags
}
